import { Coffee, Heart } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="relative bg-coffee-900 text-white/80 overflow-hidden">
      {/* Decorative background pattern */}
      <div
        className="absolute inset-0 opacity-5 pointer-events-none"
        style={{
          backgroundImage:
            'radial-gradient(circle at 20% 30%, #C17817 2px, transparent 3px), radial-gradient(circle at 80% 70%, #C17817 2px, transparent 3px)',
          backgroundSize: '80px 80px',
        }}
      />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          <div className="text-center md:text-left">
            <div className="flex items-center justify-center md:justify-start gap-2 mb-3">
              <Coffee className="w-6 h-6 text-coffee-400" />
              <span className="font-display text-xl text-white">
                {t('footer.brand')}
              </span>
            </div>
            <p className="text-sm text-white/70">
              {t('footer.slogan')}
            </p>
          </div>

          <div className="flex flex-col items-center md:items-end gap-2 text-sm">
            <p>
              <span className="text-white/60">{t('contact.phone')}</span>
            </p>
            <p>Email:{" "}
              <a
                href="mailto:info@cafelossauces.com"
                className="underline underline-offset-4 hover:text-coffee-400 transition-colors"
              >
                info@cafelossauces.com
              </a>
            </p>
          </div>
        </div>

        <hr className="my-8 border-white/10" />

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-white/60">
          <p className="flex items-center gap-1">
            {t('footer.tagline')}{" "}
            <Heart className="w-4 h-4 text-terracotta-400 fill-terracotta-400" />{" "}
            {year} © {t('footer.brand')}. {t('footer.rights')}.
          </p>
          <div className="flex items-center gap-4">
            <a
              href="https://www.facebook.com/CafeLosSauces/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white transition-colors"
            >
              Facebook
            </a>
            <a
              href="https://www.instagram.com/cafelossauces/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white transition-colors"
            >
              Instagram
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
